// 홍보물월정산 — 모바일(≤768px) 월별 카드 뷰.
// PC 테이블과 동일한 데이터·핸들러를 쓰는 순수 표시 계층 (API·상태 로직 무변경).
// 최신 월이 맨 위. 입력은 터치 크기(42px), 처리 버튼은 44px.
import React from 'react';
import { CheckCircle2, LockKeyhole, Save } from 'lucide-react';
import {
  MONEY_FIELDS, MONEY_FIELD_LABELS, formatNumber, toDraft, MoneyInput, confirmButtonState,
} from './promotionalMonthlySettlement.shared';

function StatusBadge({ row }) {
  if (row.is_settled) {
    return <span className="pms-card-badge settled"><LockKeyhole size={11} /> 정산완료</span>;
  }
  if (row.is_confirmed) {
    return <span className="pms-card-badge confirmed"><CheckCircle2 size={11} /> 확정됨</span>;
  }
  return <span className="pms-card-badge draft">작성중</span>;
}

export default function PromotionalMonthlySettlementMobile({
  rows, drafts, loading, busyKey, updateDraft, runRowAction,
}) {
  if (loading) {
    return <div className="pms-card pms-card-empty">조회 중...</div>;
  }
  if (!rows.length) {
    return <div className="pms-card pms-card-empty">조회된 월이 없습니다.</div>;
  }

  // 모바일은 최신 월이 위 (원본 배열 불변)
  const ordered = [...rows].reverse();

  return (
    <div className="pms-cards">
      {ordered.map((row) => {
        const ym = row.year_month;
        const draft = drafts[ym] || toDraft(row);
        const locked = row.is_confirmed || row.is_settled;
        const confirmBtn = confirmButtonState(row, busyKey);
        return (
          <article key={ym} className={`pms-card${locked ? ' is-locked' : ''}`}>
            {/* 헤더: 년-월 + 상태 배지 */}
            <div className="pms-card-head">
              <strong className="pms-card-month">{ym}</strong>
              <StatusBadge row={row} />
            </div>

            {/* 읽기 집계 */}
            <div className="pms-card-stats">
              <div><span>영화</span><strong>{formatNumber(row.movie_ticket_count)}</strong></div>
              <div><span>마곡장수</span><strong>{formatNumber(row.magok_ticket_count)}</strong></div>
              <div><span>홍보물</span><strong>{formatNumber(row.promotional_sales)}</strong></div>
              <div><span>택배</span><strong>{formatNumber(row.delivery_total)}</strong></div>
            </div>

            {/* 입력 5개 */}
            <div className="pms-card-inputs">
              {MONEY_FIELDS.map((field) => (
                <label key={field} className="pms-card-input-row">
                  <span>{MONEY_FIELD_LABELS[field]}</span>
                  <MoneyInput
                    value={draft[field] || ''}
                    disabled={locked}
                    onChange={(value) => updateDraft(ym, field, value)}
                  />
                </label>
              ))}
            </div>

            {/* 합계 */}
            <div className="pms-card-totals">
              <div><span>샘이콜론</span><strong>{formatNumber(row.samicolon_amount)}</strong></div>
              <div className="pine"><span>파인그룹</span><strong>{formatNumber(row.pinegroup_amount)}</strong></div>
            </div>

            {/* 처리 버튼 — PC와 동일한 disabled 로직 (확정 단추는 공용 confirmButtonState) */}
            <div className="pms-card-actions">
              <button
                type="button"
                className="pms-action-btn save"
                onClick={() => runRowAction(ym, 'save')}
                disabled={locked || busyKey === `${ym}:save`}
              >
                <Save size={15} /> 저장
              </button>
              <button
                type="button"
                className="pms-action-btn confirm"
                onClick={() => runRowAction(ym, confirmBtn.action)}
                disabled={confirmBtn.disabled}
                title={confirmBtn.title}
              >
                <CheckCircle2 size={15} /> {confirmBtn.label}
              </button>
              <button
                type="button"
                className="pms-action-btn settle"
                onClick={() => runRowAction(ym, 'settle')}
                disabled={!row.is_confirmed || row.is_settled || busyKey === `${ym}:settle`}
              >
                <LockKeyhole size={15} /> {row.is_settled ? '완료됨' : '정산완료'}
              </button>
            </div>
          </article>
        );
      })}
    </div>
  );
}
